import React from 'react';
import styled from 'styled-components';
import { device } from '../utils/device';

const MaxWidth = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg,#c5e2ffa1 50%, rgba(250,250,250,0) 100%);
`;

const Container = styled.div`
  position: relative;
  width: 1100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: 700;
  padding: 30px;

  @media ${device.tablet} {
    justify-content: space-between;
    width: 100%;
  }

  h1 {
    font-size: 30px;
    color: #004385;
    align-self: center;
    text-align: center;
    flex-grow: 2;
    margin-left: -210px;

    @media ${device.laptop} {
      margin-left: -160px;
    }

    @media ${device.tablet} {
      margin-left: 0;
      margin-right: 0;
      font-size: 20px;
    }
  }

  img {
    width: 80px;
    margin-left: ${props => props.rounded ? '0' : '100px'};
    
    @media ${device.tablet} {
      margin-left: 0;
      width: 50px;
    }

    ${props => props.rounded ? 
      `background-color: white;
       background-repeat: no-repeat;
       width: 100px;
       height: 100px;
       margin-left: 100px;
       background-size: 50%;
       background-position: 50% 50%;
       ` :
      ``
    }

  @media ${device.tablet} {
    ${props => props.rounded ? 
      `background-color: white;
       background-repeat: no-repeat;
       width: 60px;
       height: 60px;
       margin-left: 100px;
       background-size: 50%;
       background-position: 50% 50%;
       ` :
      ``
    }
  }


  }
`;

const ImageContainer = styled.div`
  background-image: url(${props => props.imageUrl});
  width: 90px;
  height: 90px;
  background-position: 50% 50%;
  background-size: 70%;
  background-repeat: no-repeat;
  margin-left: 100px;

  @media ${device.laptop} {
      margin-left: 50px;
  }

  @media ${device.tablet} {
      margin-left: 0;
      width: 60px;
      height: 60px;
  }

  ${props => props.rounded ? `
    background-color: white;
    border-radius: 50%;
  ` : `
    width: 110px;
    height: 110px;
  `}

  @media ${device.tablet} {
    ${props => props.rounded ? `
    background-color: white;
    border-radius: 50%;
    ` : `
      width: 60px;
      height: 60px;
    `}
  } 

`;

function Heading(props) {
  return (
    <MaxWidth>
      <Container {...props}>
        <ImageContainer {...props}/>
        <h1>{props.title}</h1>
      </Container>
    </MaxWidth>
  );
}

export default Heading;